export default {
	title: '设备健康度配置',
	actions: {
		add: '新增',
		edit: '修改',
		delete: '删除',
		batchDelete: '批量删除'
	},
	messages: {
		deleteConfirm: '确定删除选中的 {count} 项记录吗？',
		deleteSuccess: '操作成功',
		selectDeleteWarning: '请选择要删除的记录',
		operateSuccess: '操作成功',
		statusUpdated: '状态已更新为：{status}',
		updateFailed: '更新失败：{error}',
		unknownError: '未知错误'
	},
	form: {
		projNo: '项目编号',
		deviceNo: '设备编号',
		type: '指标类型'
	},
	table: {
		projNo: '项目编号',
		deviceNo: '设备编号',
		deviceName: '设备名称',
		number: '健康度算子个数'
	},
	dialog: {
		add: '新增',
		edit: '修改',
		cancel: '取消',
		confirm: '确定',
		detailConfigTitle: '详细配置'
	},
	detailConfig: {
		expandTitle: '{deviceNo} - {deviceName} - 详细配置'
	},
	widgetForm: {
		projNo: '所属项目',
		deviceNo: '设备名称',
		pointNo: '测点名称',
		indicatorType: '指标类型',
		type: '数据类型',
		indicatorName: '指标名称',
		upperThreshold: '上阈值',
		lowerThreshold: '下阈值',
		standardValue: '标准值',
		weight: '权重',
		gridLayout: '格栅布局',
		requiredFieldCannotBeEmpty: '必填项不能为空',
		placeholder: {
			projNo: '请输入所属项目',
			deviceNo: '请输入设备名称',
			pointNo: '请输入测点名称',
			indicatorType: '请选择指标类型',
			type: '请选择数据类型',
			indicatorName: '请输入指标名称',
			upperThreshold: '请输入上阈值',
			lowerThreshold: '请输入下阈值',
			standardValue: '请输入标准值',
			weight: '请输入权重'
		},
		options: {
			indicatorType: {
				reverse: '逆向',
				forward: '正向',
				standardValue: '标准值'
			}
		}
	},
	expandTable: {
		projNo: '项目编号',
		deviceNo: '设备编号',
		pointNo: '测点编号',
		indicatorType: '指标类型',
		type: '数据类型',
		indicatorName: '指标名称',
		isEnable: '是否启用',
		upperThreshold: '上阈值',
		lowerThreshold: '下阈值',
		standardValue: '标准值',
		weight: '权重',
		action: '操作',
		enable: '启用',
		disable: '禁用'
	}
}
